/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  const isMobile = window.matchMedia("only screen and (max-width: 767px)").matches;

  if (!isMobile) {
    var zoomImgs = [...document.querySelectorAll('.image-zoom')];
    var panes = document.querySelectorAll('.image-details');
    var modalLinks = document.querySelectorAll('.product-single__media-link'); 
    modalLinks.forEach((link) => link.style.display = 'none');

    zoomImgs.map((img, index) => {
      new Drift(img, {
        paneContainer: panes[index],
        inlinePane: false
      });
    });
  }
})();
